export default __webpack_public_path__ + "static/media/redes.d6a3845e.svg";